module.exports = __webpack_public_path__ + "img/ruby.f676dac6.svg";